import React from "react";
import { Carousel, Image } from "antd";

const Dashboard = () => {
  // Fixed array of team image URLs
  const slides = [
    {
      image: "https://cdn.shopify.com/s/files/1/0597/3783/3627/files/IMG_4135.png?v=1787040783&width=1600",
      caption: "25/07/2026 - Team Building QN",
    },
    {
      image: "https://cdn.shopify.com/s/files/1/0711/8759/5477/files/2025_07_12.jpg?v=1771593201",
      caption: "12/07/2025 - Team Building tại Nha Trang",
    },
    {
      image: "https://cdn.shopify.com/s/files/1/0711/8759/5477/files/2026_03_01.jpg?v=1771593357",
      caption: "01/03/2026 - Year End Party tại Sheraton Tây Hồ",
    },
  ];

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: 15 }}>
      <div
        style={{
          fontWeight: 500,
          padding: 24,
          marginBottom: 20,
          textAlign: "center",
          width: "100%",
        }}
      >
        Hi! Welcome to TapitaHub – your central hub for managing content across all apps in our ecosystem
      </div>
      <Carousel autoplay draggable arrows adaptiveHeight style={{ width: "100%", maxWidth: 1000, margin: "0 auto" }}>
        {slides.map((slide, index) => (
          <div key={index}>
            <Image src={slide.image} alt={slide.caption} style={{ width: "100%", borderRadius: 8 }} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Dashboard;
